import logo from "app/images/logos/Interac_e-Transfer_deposit_logo.png";

const LogoInterac = () => (
  <div className="option__nuvei-logo">
    <img
      className="option__nuvei-logo"
      width="90"
      height="33"
      src={logo}
      alt="Interac e-Transfer Logo"
    />
  </div>
);

export default LogoInterac;
